<mat-card appearance="outlined" class="flex-row-lt-sm-column gap-15 gap-lt-sm-5 padding-16">
  <div class="flex-column justify-center flex-16 flex-lt-sm-start flex-lt-sm-50">
    <h4 class="batch-number">{{ batch.batchNumber }}
      @if (batch.batchComments?.length > 0) {
        <mat-icon
          class="batch-comment-circle"
          [matTooltip]="batchCommentTooltip"
          matTooltipPosition="above"
        matTooltipClass="multiline-tooltip">circle</mat-icon>
      }
    </h4>
    <div class="flex-row">
      @if (batch.expirationDate) {
        <div class="expiration-date">
          {{'dashboard.expDate' | translate}}
        </div>
      }
      @if (batch.expirationDate) {
        <div [ngClass]="!isExpired ? 'expiration-date' : 'expiration-date expired'">
          {{batch.expirationDate | date: 'dd.MM.y'}}
        </div>
      }
    </div>
    <div class="flex-row flex-lt-sm-row gap-lt-sm-4 gap-8 flex-lt-md-column">
      <span class="product-number">{{ batch.productName }}</span>
      @if (batch.productType !== 'BODY_BUMPER') {
        <span
          class="product-type"
          [ngClass]="{ 'is-bumper': batch.productType === 'BUMPER', 'is-body': batch.productType === 'BODY' }"
          >
          {{ batch.productType }}
        </span>
      }
      @if (batch.productType === 'BODY_BUMPER') {
        <div>
          <span class="product-type is-body">{{ 'dashboard.body' | translate }}</span>
          <span class="product-type is-bumper">{{ 'dashboard.bumper' | translate }}</span>
        </div>
      }
    </div>
    @if (!!batch.batchState && batch.batchState !== 'COMPLETED' && batch.batchState !== 'ON_HOLD') {
      <div
        class="project-state-item"
        >
        @if (batch.batchState === 'IN_LINE') {
          <span>
            {{ 'dashboard.recentLine' | translate }}
          </span>
        }
        @if (batch.batchState === 'IN_EXAMINATION') {
          <span>
            {{ 'dashboard.recentAudit' | translate }}
          </span>
        }
      </div>
    }
  </div>

  <div class="flex-column flex-33 flex-lt-sm-100">
    <colimo-forecast-measurement
      [batch]="batch"
      [selectedForecastMeasurement]="selectedForecastMeasurement"
      (selectedForecastMeasurementChanged)="onSelectedForecastMeasurementChanged($event)">
    </colimo-forecast-measurement>

    @if (!batch.forecastAvailable) {
      <colimo-accordion-wrapper
        [headerTitle]="'dashboard.dateInfoHeadline' | translate"
        [showOnlyOnMobile]="true"
        >
        <div class="flex-row margin-bottom">
          @if (!!batch.approvalDate) {
            <div class="flex-50">
              <p class="batch-info-label">{{ 'dashboard.release' | translate }}</p>
              <p class="batch-info-text">{{ batch.approvalDate | date: 'dd.MM.y' }}</p>
            </div>
          }
          @if (!!batch.examinationStartDate) {
            <div class="flex-50">
              <p class="batch-info-label">{{ 'dashboard.completionTinting' | translate }}</p>
              <p class="batch-info-text">{{ batch.examinationStartDate | date: 'dd.MM.y' }}</p>
            </div>
          }
        </div>
        @if (batch.kpiLines) {
          <div
            [ngClass]="!(batch?.approvalDate || batch?.examinationStartDate) ? 'added-top-margin' : 'no-gap'"
            >
            @for (line of batch.kpiLines; track line.lineNumber; let i = $index; let lastItem = $last) {
              <div class="aligned-divider padding-top-bottom">
                @if (isMobile && (line.dockingDate || line.lastMeasurementDate)) {
                  <div>
                    <div>
                      <p class="line-label">{{ 'dashboard.line' | translate }} {{ line | lineName }}</p>
                    </div>
                  </div>
                }
                <div class="flex-row">
                  @if (!!line.dockingDate) {
                    <div class="flex-50">
                      @if (!isMobile) {
                        <p class="batch-info-label" [ngClass]="i === 0 ? 'first' : 'not-first'">
                          {{ 'dashboard.dockedLine' | translate }}
                        </p>
                      }
                      @if (isMobile) {
                        <p class="batch-info-label">{{ 'dashboard.dockedLine' | translate }}</p>
                      }
                      <p class="batch-info-text">{{ line.dockingDate | date: 'dd.MM.y' }}</p>
                    </div>
                  }
                  @if (!!line.lastMeasurementDate) {
                    <div class="flex-50">
                      @if (!isMobile) {
                        <p class="batch-info-label" [ngClass]="i === 0 ? 'first' : 'not-first'">
                          {{ 'dashboard.lastMeasurement' | translate }}
                        </p>
                      }
                      @if (isMobile) {
                        <p class="batch-info-label">{{ 'dashboard.lastMeasurement' | translate }}</p>
                      }
                      <p class="batch-info-text">{{ line.lastMeasurementDate | date: 'dd.MM.y' }}</p>
                    </div>
                  }
                </div>
                @if (!lastItem) {
                  <mat-divider></mat-divider>
                }
              </div>
            }
          </div>
        }
      </colimo-accordion-wrapper>
    }
  </div>

  <div
    class="flex-column flex-51 flex-lt-sm-100"
    [ngClass]="
      (batch?.approvalDate || batch?.examinationStartDate) && batch.kpiLines?.length && !isMobile
        ? 'with-gap'
        : 'no-gap'
    "
    >
    @if (batch.kpiLines.length || batch.cpiForecast || batch.forecastAvailable) {
      <colimo-accordion-wrapper
        [headerTitle]="'KPIs'"
        [showOnlyOnMobile]="true"
        [openOnStart]="true"
        >
        @if (!batch.forecastAvailable && batch.kpiLines) {
          <div>
            @for (kpiLine of batch.kpiLines; track kpiLine.lineNumber; let i = $index; let lastItem = $last) {
              <div
                [ngClass]="batch?.approvalDate || batch?.examinationStartDate ? 'kpi-line' : 'kpi-line more-margin'"
                >
                <colimo-kpi-line
                  [forecastAvailable]="batch.forecastAvailable"
                  [cpiForecast]="batch.cpiForecast"
                  [kpiLine]="kpiLine"
                  [batchId]="batch.batchId"
                  [projectId]="project.id"
                  [modelId]="modelId"
                  [projectPage]="projectPage"
                  [batchState]="batch.batchState"
                  [isColorRoute]="isColorRoute"
                  [batchLineSelections]="batchLineSelections"
                  [batch]="batch"
                  [project]="project"
                  [showVectorButton]="showVectorButton"
                  >
                </colimo-kpi-line>
                @if (!lastItem) {
                  <mat-divider></mat-divider>
                }
              </div>
            }
          </div>
        }
        @if (batch.forecastAvailable && batch.referenceBatches) {
          <colimo-forecast
            [referenceBatches]="batch.referenceBatches"
            [batch]="batch"
            [project]="project"
            [showVectorTintingButton]="showVectorButton"
            [selectedForecastMeasurement]="selectedForecastMeasurement"
            (eventForecastInit)="forecastInit($event)"
            >
          </colimo-forecast>
        }
      </colimo-accordion-wrapper>
    }
  </div>
</mat-card>
